<template><zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >

    <z-page class="table-hardcode" content-class="pa0" title="Deposit Sedia Ada">

        <div class="message-box">
          <w-transition-fade>
            <w-alert
              class="my0 text-light"
              v-if="form.submitted"
              success
              no-border>
              The form is valid, ready to send it!
            </w-alert>

            <w-alert
              class="my0 text-light"
              v-else-if="form.valid === false"
              error
              no-border>
              Terdapat {{ form.errorsCount }} ralat di dalam borang ini.
            </w-alert>
          </w-transition-fade>
        </div>
        <w-form 
          class=""
          v-model="form.valid"
          v-model:errors-count="form.errorsCount"
          @validate="send"
          @success="Success">

        <w-dialog
                    v-model="dialog.show"
                    :fullscreen="dialog.fullscreen"
                    :width="dialog.width"
                    :persistent="dialog.persistent"
                    :persistent-no-animation="dialog.persistentNoAnimation"
                    title-class="primary-light1--bg white"
                >
                    <template #title> Tambah Profil </template>
                    <template #default>
                        <w-form
                            ref="form"
                            v-model="dialog.valid"
                            @validate="submitProfil"
                            @success="success"
                        >
                         <div class="title4 mb2">Kategori Profil*</div>
                            <w-radios :items="kategori" 
                                v-model="form_profil.kategori"
                                :sort="false"
                                :cache="false" 
                                :validators="[validators.required]"
                                inline></w-radios>
                            <br>
                            
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="ID Pengenalan/No. Syarikat*"
                                    name="ID Pengenalan/No. Syarikat*"
                                    v-model="form_profil.no_id"
                                    :validators="[validators.required]"
                                />&nbsp;&nbsp;&nbsp;
                                <z-input
                                    label="Nama*"
                                    name="Nama*"
                                    v-model="form_profil.nama"
                                    :validators="[validators.required]"
                                />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="Alamat"
                                    name="Alamat"
                                    v-model="form_profil.alamat1"
                                />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    name="Alamat"
                                    v-model="form_profil.alamat2"
                                />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    name="Alamat"
                                    v-model="form_profil.alamat3"
                                />
                            </w-flex>
                            <z-lookup
                                label="Poskod"
                                name="poskod"
                                :url="service_deposit + 'lookup/lkp_poskod'"
                                :sort="false"
                                :cache="false"
                                v-model="form_profil.lkp_poskod_id"
                            /><br />
                            <w-flex
                                justify-center
                                align-center
                                v-if="form_profil.bandar"
                            >
                                <div class="xs6">
                                    <h5 class="fw-semibold m0">Bandar :</h5>
                                    {{ form_profil.bandar }}
                                </div>

                                <div class="xs6">
                                    <h5 class="fw-semibold m0">Negeri :</h5>
                                    {{ form_profil.negeri }}
                                </div>
                                <br />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="No. Telefon"
                                    name="No. Telefon"
                                    v-model="form_profil.no_tel"
                                    :validators="[validators.numeric]"
                                />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="Email"
                                    name="Email"
                                    v-model="form_profil.emel"
                                    
                                />
                            </w-flex>
                           
                        </w-form>
                    </template>
                    <template #actions>
                        <div class="spacer" />
                        <w-button
                            bg-color="grey-light5--bg"
                            @click="dialog.show = false"
                            >Tutup</w-button
                        >
                        <w-button
                            class="ml1"
                            :loading="dialog.loading"
                            :disabled="dialog.valid === false"
                            @click="$refs.form.validate()"
                            >Daftar</w-button
                        >
                    </template>
                </w-dialog>
                <w-card bg-color="" class="">
                    <h3>Profil</h3>
                    <w-flex class="mt3">
                        <div class="xs11">
                            <z-input
                                label="Profil *"
                                name="profil_id"
                                readonly
                                @click="profil"
                                :validators="[validators.required]"
                            />
                        </div>
                        <div class="xs1">
                            &nbsp;
                            <w-icon @click="dialog.show = true"
                                >fal fa-plus</w-icon
                            >
                        </div>
                    </w-flex>
                    <br />

                    <w-flex justify-center align-center v-if="form.no_id">
                    <div class="xs6">
                      <h5 class="fw-semibold m0">
                            Profil :
                      </h5>
                            {{form.no_id.toUpperCase()}} | {{form.nama.toUpperCase()}}
                    </div>
                    <div class="xs6">
                        <h5 class="fw-semibold m0">
                          Alamat :
                        </h5>
                        <span >
                            <template v-if="form.alamat1"> 
                                {{form.alamat1.toUpperCase()}}, 
                            </template>
                            <template v-if="form.alamat2"> 
                                {{form.alamat2.toUpperCase()}}, 
                            </template>
                            <template v-if="form.alamat3"> 
                                {{form.alamat3.toUpperCase()}}, 
                            </template>
                            <template v-if="form.poskod"> 
                                {{form.poskod.toUpperCase()}},
                            </template> 
                            <template v-if="form.bandar"> 
                                {{form.bandar.toUpperCase()}}, 
                            </template>
                            <template v-if="form.negeri"> 
                                {{form.negeri.toUpperCase()}}
                            </template>
                        </span>
                    </div>
              </w-flex> </w-card
                ><br />
            <h3>Butiran</h3>
                    <w-flex class="mt3">
                        <div class="xs6 mr5">
                            <w-input  v-model="form.no_cagaran" required label="No. Deposit *" :validators="[validators.required]"/> 
                        </div>
                        <div class="xs6 mr5">
                            <w-input   v-model="form.tarikh_daftar" required label="Tarikh Deposit *" type="date" :validators="[validators.required]" />
                        </div>
                        <div class="xs6 mr5">
                            <z-money
                                v-model:originalValue="form.amaun_deposit"
                                label="Amaun Deposit (RM)*"
                                v-on:keyup="baki(form)"
                                :validators="[validators.required]">
                            </z-money>
                        </div>
                    </w-flex>

                    <!-- <w-form ref="form" v-model="dialog.valid" @validate="muatNaik" @success="success"> -->
                    <w-flex class="mt3">
                        <div class="xs6 mr5">
                            <w-input  v-model="form.no_fail" label="No. Fail " placeholder="Cth:040001234" /> 
                        </div>
                        <div class="xs6 mr5">
                            <template v-if="form.akaun_id">
                                <z-lookup label="Kod Akaun *" name="akaun" :url='service_utiliti+"lookup/akaun_akhir"' :sort="false" :cache="false" v-model="form.akaun_id" :validators="[validators.required]" />
                            </template>
                            <template v-else>
                                <z-lookup label="Kod Akaun *" name="akaun" :url='service_utiliti+"lookup/akaun_akhir"' :sort="false" :cache="false" v-model="form.akaun_id" @pilih="getJenis(form)" :validators="[validators.required]" />
                            </template>
                            
                            
                        </div>
                        <div class="xs6 mr5">
                            <z-money
                                v-model:originalValue="form.amaun_inbois"
                                label="Amaun Telah Bil (RM)*" required
                                v-on:keyup="baki(form)"
                                :validators="[validators.required]"
                          ></z-money>
                        </div>
                    </w-flex>
                    <!-- </w-form> -->
                    <w-flex class="mt3">
                        <div class="xs6 mr5">
                        </div>
                        <div class="xs6 mr5">
                             <template v-if="form.lkp_deposit_jenis_id">
                                <template v-if="form.ind_deposit_jenis_id">
                                   <z-lookup label="Jenis *" name="deposit_jenis" :url='service_deposit+"lookup/deposit_jenis"' :sort="false" :cache="false" v-model="form.lkp_deposit_jenis_id"  />
                               </template>
                               <template v-else>
                                   <z-lookup label="Jenis *" name="false" :url='service_deposit+"lookup/deposit_jenis"' :sort="false" :cache="false" v-model="form.lkp_deposit_jenis_id"  />
                               </template>
                            </template>
                        </div>
                        <div class="xs6 mr5">
                           <z-money
                              v-model:originalValue="form.amaun_belum_inbois"
                              label="Amaun Belum Bil (RM)" 
                              readonly
                          ></z-money>
                        </div>
                    </w-flex>
                    <w-flex class="mt3">
                        <div class="xs6 mr5">
                        </div>
                        <div class="xs6 mr5">
                         <!-- <w-radios v-model="form.lkp_deposit_butiran_id" :items="butiranJenisSediaAda" inline ></w-radios> -->
                            <template v-if="form.lkp_deposit_jenis_id == 1">
                            <z-lookup
                                    label="Butiran *"
                                    name="Butiran"
                                    :url="service_deposit + 'lookup/deposit_butiran'"
                                    :sort="false"
                                    :cache="false"
                                    v-model="form.lkp_deposit_butiran_id"
                                    :validators="[validators.required]"
                            />
                            </template>
                        </div>
                        <div class="xs6 mr5">
                            <z-money
                              v-model:originalValue="form.amaun_baki"
                              label="Amaun Baki/Bayaran (RM)"
                          ></z-money>
                        </div>
                    </w-flex>

                    <w-flex>
                            <w-textarea  v-model="form.keterangan" required label="Keterangan" placeholder="Sila Masukan Keterangan" /> 
                    </w-flex>

            

            <w-flex justify-center align-center class="mt5">
              <div class="w-card__content content-hardcode">                
                <table class="table-dashboard" width="100%">
                    <thead>
                        <tr>
                            <td>Tarikh *</td>
                            <td>Jenis Transaksi *</td>
                            <td>No. Rujukan *</td>
                            <td>Keterangan</td>
                            <td>Amaun(RM) *</td>
                            <!-- <td>Baki Deposit(RM)</td> -->
                            <td> <w-icon class="mr1" @click="addItem">fal fa-plus</w-icon></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="dt, index in form.deposit_trans">
                            <td >
                                <w-input v-model="dt.tarihk_daftar" required label="Tarikh" type="date" :validators="[validators.required]" />
                            </td>
                            <td>
                                <z-lookup :url='service_deposit+"lookup/deposit_trans"' :sort="false" :cache="false" v-model="dt.lkp_deposit_trans_id" required :validators="[validators.required]" />
                            </td>
                            <td>
                              <w-input  v-model="dt.no_rujukan" required   :validators="[validators.required]" /> 
                            </td>
                            <td>
                              <w-input  v-model="dt.keterangan"  /> 
                            </td>
                            <td>
                                <z-money v-model:originalValue="dt.amaun" required validators="[validators.required]"/>
                            </td>
                            <td><w-icon class="mr1" @click="removeItem(index)">fal fa-trash</w-icon></td>
                        </tr>
                    </tbody>
                </table>
              </div>

            </w-flex>

            <w-flex class="mt3" wrap align-center justify-end>
                <div class="spacer" />

                <w-button class="my1" bg-color="warning" dark  @click="back()" >Kembali</w-button>
                &nbsp; &nbsp;
                <template v-if="form.lkp_deposit_status_id == 3 ">
                    <w-button
                      class="my1"
                      type="submit"
                      :disabled="form.valid === false"
                      :loading="form.submitted && !form.sent"
                      >
                    <w-icon dark tile class="mr2">fal fa-save</w-icon>
                    Simpan
                    </w-button>
                    &nbsp;&nbsp;
                    <w-button class="my1" @click="sendUpdate()" type="button" :loading="form.submitted && !form.sent">
                        <w-icon dark tile class="mr2">fal fa-paper-plane</w-icon> Hantar
                    </w-button>
                </template>
                <template v-if="!form.lkp_deposit_status_id">
                <w-button class="my1 error-dark1--bg"  dark  @click="reset()" >Reset</w-button>
                &nbsp; &nbsp;
                <template v-if="form.no_id != null">
                    <w-button
                      class="my1"
                      type="submit"
                      :disabled="form.valid === false"
                      :loading="form.submitted && !form.sent"
                      >
                    <w-icon dark tile class="mr2">fal fa-save</w-icon>
                    Simpan
                    </w-button>
                </template>
              </template>
            </w-flex>
            <w-dialog
                v-model="dialogProfil.show"
                :fullscreen="dialogProfil.fullscreen"
                :width="dialogProfil.width"
                :persistent="dialogProfil.persistent"
                :persistent-no-animation="dialogProfil.persistentNoAnimation"
                title-class="primary-light1--bg white"
            >
                <template #title>
                    <w-icon class="mr2">fal fa-user</w-icon>
                    Carian Profil
                </template>
                <div class="page-wrapper-portal">
                    <w-flex justify-center align-center>
                        <div class="xs8">
                            <w-input
                                label="No KP | Nama"
                                v-model="carian_profil.q"
                            >
                            </w-input>
                        </div>
                        <div class="xs4">
                            <w-button class="ml1" @click="cariProfil"
                                >Cari</w-button
                            >
                        </div>
                    </w-flex>
                    <div class="table-profil-scrol">
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No KP | Nama
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        Pilih
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dt, index) in profils">
                                    <td class="w-table__cell text-left">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.label }}
                                    </td>
                                    <td class="w-table__cell text-right">
                                        <w-radio
                                            class="mr2"
                                            v-model="form.profil_id"
                                            :return-value="dt.value"
                                            @click="pilihProfil(dt)"
                                        ></w-radio>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="dialogProfil.show = false"
                        >Tutup</w-button
                    >
                </template>
            </w-dialog>

        </w-form>
      </z-page >

  </zen-one>
</template>

<script>

import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'

export default {
  extends: ZResource,
components: {
  
},

  props: {
    id: [Array, Object, String],
  },
  setup () {
    
  },
  data() {
    return {
  
        resourceurl: this.service_deposit + "sediaAda",
        reload: true,
        // akaun_id : 3,
        crumbs: [
              { label: 'iHasil', route: '/' },
              { label: 'Deposit', route: '/deposit' },
              { label: 'Sedia Ada', route: '/sediaAda' },
        ],
        showCard: false,
        i_ind : null,
        carian_profil : {q: ''},
        form_profil: {},
        amaun_inbois:{},
        amaun_baki: {},
        amaun_belum_inbois: {},
        butiranJenisSediaAda: [],
        kategori: [
            {
                value: 1,
                label: "Individu",
            },
            {
                value: 2,
                label: "Syarikat",
            },
        ],
        form_cari: {},
        form_akaun: {},
            profils: [],
            dialogProfil: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 800,
                form: { nama: "", email: "" },
            },
        form: {
          valid: null,
          submitted: false,
          sent: false,
          errorsCount: 0,
          no_tel: "",
          akaun_id: null,
          amaun_deposit: 0.0,
          amaun_inbois: 0.0,
          amaun_baki: 0.0,
          amaun_pelarasan: 0.0,
          amaun_pewartaan: 0.0,
          amaun_belum_inbois: 0.0,
        },
        validators: {
                required: (value) => !!value || "Medan Ini Wajib Isi",
                consent: (value) => !!value || "You must agree",
                email: (value) =>
                    !!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i) ||
                    "Sila Semak Format Email",
                numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
            },
        
    }
},
methods: {
    back() {
      window.history.back();
    },
    addItem() {
      this.form.deposit_trans.push( {created_at : null, keterangan : null, no_rujukan : null, keterangan : null, amaun : null, lkp_deposit_trans_id: null, amaun_tambah_deposit : null});
    },

    removeItem(index) {
      this.form.deposit_trans.splice(index, 1);
    },

    poskodDetail() {
            this.$zcomm
                .get(
                    this.service_deposit +
                        "lookup/lkp_poskod_detail/" +
                        this.form_profil.lkp_poskod_id
                )
                .then((res) => {
                    this.form_profil.negeri = res.negeri;
                    this.form_profil.lkp_negeri_id = res.lkp_negeri_id;
                    this.form_profil.bandar = res.bandar;
                    this.form_profil.lkp_jenis_alamat_id = 1;
                    this.form_profil.jabatan_id = 1;
                });
        },
        profil() {
            this.dialogProfil.show = 1;
        },

        // getData(){
        //   alert()
        // },

        cariProfil() {
            if (this.carian_profil.q.length > 1) {
                this.$zcomm
                    .post(
                        this.service_utiliti + "lookup/profil",
                        this.carian_profil,
                        {}
                    )
                    .then((res) => {
                        console.log(res);
                        this.profils = res;
                    });
            }
        },

        pilihProfil(dt) {
            //   // alert('asds');
            this.form.profil_keterangan = dt.label;
            this.form_cari.id = dt.value;
            this.profilDetail();
        },
        profilDetail() {
            this.$zcomm
                .get(this.service_deposit + "profil/" + this.form_cari.id)
                .then((res) => {
                    this.form.profil_id = res.id;
                    this.form.no_id = res.no_id;
                    this.form.kategori = res.kategori;
                    this.form.nama = res.nama;
                    this.form.alamat1 = res.alamat1;
                    this.form.alamat2 = res.alamat2;
                    this.form.alamat3 = res.alamat3;
                    this.form.poskod = res.poskod;
                    this.form.bandar = res.bandar;
                    this.form.negeri = res.negeri;
                });
        },
        akaunDetail() {
            // alert('asds');
            this.$zcomm
                .get(
                    this.service_deposit +
                        "lookup/akaun_detail/" +
                        this.form.akaun_id
                )
                .then((res) => {
                    this.form_akaun.kod = res.kod;
                    this.form.keterangan = res.kod+ ' | ' +res.keterangan;
                    this.form_akaun.keterangan = res.keterangan;
                    this.form_akaun.aras_akhir = res.aras_akhir;
                });
        },

        jenisButiranDetailSediaAda() {
        
            this.butiranJenisSediaAda =[];
            this.$zcomm.get(this.service_deposit+'lookup/jenis_butiran/'+this.form.lkp_deposit_jenis_id).then(res => {
                  this.butiranJenisSediaAda = res;
                });
        },
    cekAmaun(){
      this.form.amaun = 0;
      for (var i in this.form.deposit_trans) {
        this.form.amaun = this.form.amaun + parseFloat(this.form.deposit_trans[i].amaun);
      }
    },
    reset(){
      this.form = {
      show : true,
      deposit_trans : [{created_at : null, keterangan : null, no_rujukan : null, keterangan : null, amaun : null, lkp_deposit_trans_id: null, amaun_tambah_deposit: null}]
      }
    },

    send() {
        this.lkp_deposit_trans_id = this.lkp_deposit_trans_id
        if (this.form.id > 0) {
            this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
                .then(res => {
                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                    }
                })
                .catch(err => {

                })
                .finally(() => {
                      
                });
        }else {
            this.$zcomm.post(this.resourceurl, this.form)
            .then((res) => {
            if (typeof this.onAfterAdd === "function") {
                  this.onAfterAdd();
            }
              this.$zutil.notify("Rekod telah berjaya di Simpann");
              this.$inertia.visit(this.$route("deposit.sedia_ada.semak",res.id));
            })
            .catch((err) => {})
            .finally(() => {
              // <inertia-link :href='$route("deposit.show",item.id)'>
            });
        }
    },
    sendUpdate(){
        this.loading = true
        this.form.lkp_deposit_status_id = 1;
        this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
        .then(res => {
          

        if (typeof this.onAfterEdit === "function") {
            this.onAfterEdit()
          }
          this.$zutil.notify("Rekod telah berjaya di Simpann");
          this.$inertia.visit(this.$route("deposit.index"));
          })
          .catch(err => {

          })
          .finally(() => {
              
             this.form.loading = false;

        });
    
    },
   submitProfil() {
        
            if (this.dialog.valid == true) {
            //     this.form.valid = false

            // if (this.$refs.form.validate()) {
                this.dialog.loading = true

                
                    this.$zcomm.post(this.service_deposit+'profil' , this.form_profil)
                        .then(res => {
                          // console.log(res)
                          //update displayed record
                          // this.$page.flash.success = "Rekod telah ditambah"
                          this.mapreturneddata(res)
                          this.dialog.show = false;
                          if (typeof this.onAfterAdd === "function") {
                            this.onAfterAdd()
                          }
                          this.form.profil_id = res.id;
                          this.form.no_id = res.no_id;
                          this.form.nama = res.nama;
                          this.form.alamat1 = res.alamat1;
                          this.form.alamat2 = res.alamat2;
                          this.form.alamat3 = res.alamat3;
                          this.form.poskod = res.poskod;
                          this.form.bandar = res.bandar;
                          this.form.negeri = res.negeri;
                          this.form.kategori = res.kategori;
                            // this.$inertia.visit(this.$page.url)
                          
                        })
                        .finally(() => {
                            this.dialog.loading = false;

                          // $('#' + this.resourceurl).modal('hide')
                        });
                        this.cariProfil();
                
            }
        },
    
        baki(form) {
            form.amaun_belum_inbois = form.amaun_deposit - form.amaun_inbois;
            form.amaun_baki = form.amaun_inbois;
        },

        getAkauns() {
            this.$zcomm.get(this.service_deposit+'lookup/akaun_akhir').then(res => {
                  this.akauns = res;
                });
        },


        getJenis(form){
        
            if(form.ind_deposit_jenis_id == 0){
                    form.ind_deposit_jenis_id = 1
            }else{
                form.ind_deposit_jenis_id = 0
            }
            for (var a in this.akauns) {
                if(form.akaun_id == this.akauns[a].value){
                    form.lkp_deposit_jenis_id = this.akauns[a].deposit_jenis;
                }
            }
         },

},
  watch: {
        files: function (val) {
            // console.log(val);
            console.log("work");
        },
        "form_profil.lkp_poskod_id": function (q) {
            this.poskodDetail();
        },
        "form_cari.id": function (q) {
            this.profilDetail();
        },
        "form.akaun_id": function (q) {
            this.akaunDetail();
        },
        "form.lkp_deposit_jenis_id": function (q) {
            this.jenisButiranDetailSediaAda();
        },
    },

  mounted() {
    this.getAkauns();
    if(this.id == 0){
      this.form = {
        show: true,
        amaun_inbois : null,
        amaun_deposit : null,
        amaun_baki : null,
        amaun_pelarasan : null,
        amaun_pewartaan : null,
        amaun_belum_inbois : null,
        deposit_trans : [{created_at : null, keterangan : null, no_rujukan : null, keterangan : null, amaun : null, lkp_deposit_trans_id: null, amaun_tambah_deposit : null}]
      }
      }
  },
    
}

</script>

<style>


</style>